import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { Raiz } from "./paginas/Raiz";
import { Inicio } from "./paginas/Inicio";
import { rutasCampanas } from "./campanas/rutas";
import { Tickets } from "./paginas/Tickets";
import { rutasSemaforo } from "./tickets/rutas";

const raiz = createRootRoute({ component: Raiz });
const inicio = createRoute({ getParentRoute: () => raiz, path: "/", component: Inicio });
const tickets = createRoute({ getParentRoute: () => raiz, path: "/tickets", component: Tickets });

// Un solo árbol con las dos vistas: /campanas/* (V360) y /tickets/*, /tablero, /area, /avisos (Semáforo).
// Qué se enseña primero lo decide la vista (Inicio.tsx y Raiz.tsx), no el router.
export const router = createRouter({
  routeTree: raiz.addChildren([inicio, ...rutasCampanas(raiz), tickets, ...rutasSemaforo(raiz)]),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
